'use strict'

import $ from 'jquery'

export default function () {
    $('#openSearch').on('click', function (e) {
        e.stopPropagation()
        $('.search-popin').addClass('is-active')
        setTimeout(() => {
            $('.search-popin__input').focus()
        }, 200)
    })

    $('.search-popin').on('click', function (e) {
        e.stopPropagation()
    })

    $('body').on('click', function () {
        $('.search-popin').removeClass('is-active')
    })
}
